import { IBreezeEntity } from "@common/lib/data/breeze-entity.interface";
import { Entity, EntityAspect, EntityType } from "breeze-client";

export abstract class BaseEntity<T> implements IBreezeEntity<T> {
    public readonly entityAspect!: IBreezeEntityAspect<T>;
    public readonly entityType!: EntityType;

    // Supplied at runtime by Breeze's backing-store adapter.
    public readonly getProperty!: Entity["getProperty"];
    public readonly setProperty!: Entity["setProperty"];
    public isComplete!: boolean;
}

interface IBreezeEntityAspect<T> extends EntityAspect {
    originalValues: Partial<T>;
}
